module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ieQBui/tc-custom/9781524858971.jpg?1708400931753",
      "alt": "This image is the cover for the book Sorry I Barfed on Your Bed Again"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Sorry I Barfed on Your Bed Again\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Tess wants you to know that she intends to continue throwing up freely as long as the new baby gets to—fair is fair. Ovid would like to inform you that he’s giving up one of his nine lives in order to avoid a visit to the vet—he’ll miss you and knows you understand. And Quinn assures you that she’ll protect you from whatever it is that’s rolled under the table with all the righteous fury in her little body—even if only turns out to be a dropped olive."), _c('br'), _vm._v(" "), _c('br'), _c('i', [_vm._v("Sorry I Barfed on Your Bed Again")]), _vm._v(" is full of funny letters and heartwarming photos—a perfect gift for cat lovers."), _c('br')]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jeremy Greenberg\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Andrews McMeel Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0